"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SubModule_1 = require("./SubModule");

var procedures_1 = require("../../procedures");
/**
 * Namespace that handles all Controller related functionality
 */


var Controller =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Controller, _SubModule_1$SubModul);

  function Controller() {
    var _this;

    _classCallCheck(this, Controller);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Controller).apply(this, arguments));
    /**
     * Set the address of the Security Token's Controller. The controller may perform forced transfers
     *
     * @param args.controller - security token's controller address
     */

    _this.modifyController = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var controller, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                controller = args.controller;
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.SetController({
                  symbol: symbol,
                  controller: controller
                }, this.context);
                return _context.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Permanently disable controller functionality
     *
     * @param args.signature - optional signed data. If not passed, signing will be requested when the transaction queue is run. The data can be generated beforehand by the token owner calling `signDisableAck`
     */


    _this.disable = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.DisableController(Object.assign({}, args, {
                  symbol: symbol
                }), this.context);
                return _context2.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Perform a forced transfer of tokens from one address to another. You must be the
     * Security Token's controller to do this
     *
     * @param args.amount - amount of tokens to be transferred
     * @param args.from - address from which to transfer tokens
     * @param args.to - address that will receive the tokens
     * @param args.reason - optional message to describe why the transfer occurred
     * @param args.data - optional data used to validate the transfer
     */


    _this.transfer = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var amount, from, to, _args$reason, reason, _args$data, data, symbol, procedure;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                amount = args.amount, from = args.from, to = args.to, _args$reason = args.reason, reason = _args$reason === void 0 ? '' : _args$reason, _args$data = args.data, data = _args$data === void 0 ? '' : _args$data;
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.ControllerTransfer({
                  symbol: symbol,
                  amount: amount,
                  from: from,
                  to: to,
                  log: reason,
                  data: data
                }, this.context);
                return _context3.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Redeem (burn) an amount of tokens from a token holder. Only the Security Token's controller can call this
     * This operation is subject to transfer restrictions and the amount is limited by the token holder's balance.
     * `balanceOf(tokenHolder)` tokens) and potentially also need to respect other transfer restrictions.
     *
     * @param args.amount - amount of tokens to be redeemed
     * @param args.address - address of the token holder
     * @param args.reason - optional message to describe why the redemption occurred
     * @param args.data - optional data used to validate the transfer
     */


    _this.redeem = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.ControllerRedeem(Object.assign({
                  symbol: symbol
                }, args), this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };
    /**
     * Generate a signature string that can be used to permanently disable the Security Token's controller functionality
     *
     * **Note that only the owner's signature is valid for this operation**
     */


    _this.signDisableAck = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                symbol = this.securityToken.symbol;
                procedure = new procedures_1.SignDisableControllerAck({
                  symbol: symbol
                }, this.context);
                return _context5.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };

    return _this;
  }

  return Controller;
}(SubModule_1.SubModule);

exports.Controller = Controller;